/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import './PublicHeader.scss';
import Wrapper from 'components/Wrapper';
import Logo from 'assets/images/logo_white.png';
import { Fetch, ROUTES } from 'config/constants';
import { Phone } from 'components/SvgIcons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { getAllCategories } from 'api/category';
import { withRouter } from 'react-router-dom';

class PublicHeader extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            menus: [],
            isheaderopen: false,
            width: 0,
            height: 0,
            openedSubmenu: '',
            categories: [],
            customMenuItems: {
                careAbilitySlings: {
                    url: 'https://prismmedical.co.uk/care-ability-slings/',
                    name: 'Care-ability Slings'
                }
            }
        };
    }

    componentDidMount() {
        this.getmenu();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        getAllCategories().then(({ data: { data } }) => {
            this.setState({ categories: data });
            // console.log(data);
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    getmenu = async () => {
        try {
            const resp = await Fetch({ api: 'https://prismmedical.co.uk/wp-json/menus/v1/menus/main', token: false, type: 'GET' });

            this.setState({ menus: resp.items });
        } catch (err) {
            //
        }
    }

    toggleHeader = () => this.setState(_oldState => ({ isheaderopen: !_oldState.isheaderopen, openedSubmenu: '' }));

    toggleSubMemu = (name) => {
        const { openedSubmenu } = this.state;

        if (openedSubmenu === name) return this.setState({ openedSubmenu: '' });

        this.setState({ openedSubmenu: name });
    }

    routeProduct = (e, product) => {
        e.preventDefault();
        window.location.href = `${window.location.origin}/product/category-details/${product.slug}`;
    }

    goToProducts = e => {
        window.location.replace(ROUTES.HOME);
    }

    render() {
        const { width, isheaderopen, menus, openedSubmenu, categories, customMenuItems } = this.state;

        return (
            <div className='PublicHeader'>
                <Wrapper>
                    <div className='PublicHeader__content'>
                        <div className='PublicHeader__content--menu_bar' onClick={() => this.toggleHeader()}>
                            {isheaderopen ? <FontAwesomeIcon icon={faTimes} size='2x' color='#fff' /> : <FontAwesomeIcon icon={faBars} size='2x' color='#fff' />}
                        </div>
                        <div className='PublicHeader__content--logo'>
                            <img src={Logo} alt='logo' className='PublicHeader__content--logo--img' />
                        </div>
                        <div className='PublicHeader__content__menu' style={{ display: width > 992 ? 'flex' : (isheaderopen ? 'flex' : 'none') }}>
                            <ul className='PublicHeader__content__menu--ul'>
                                {menus.map((menu, i) => {
                                    if (menu.title === 'Products') {
                                        if (width < 992) {
                                            return <div key={i}>
                                                <li className='PublicHeader__content__menu--ul--li' onClick={() => this.toggleSubMemu(menu.title)} >
                                                    {menu.title}
                                                    <FontAwesomeIcon icon={faCaretDown} size='1x' color='#fff'
                                                        style={{ marginLeft: '6px' }} />

                                                    <ul className='PublicHeader__content__menu--ul--li--childUl' style={{ display: openedSubmenu === menu.title ? 'contents' : 'none' }}>
                                                        {categories.map((child, i) =>
                                                            <a href={ROUTES.CATEGORY_DETAILS(child.slug)} key={i}>
                                                                <li className='PublicHeader__content__menu--ul--li--childUl--li'>
                                                                    {child.name}
                                                                </li>
                                                            </a>
                                                        )}
                                                        <a href={customMenuItems.careAbilitySlings.url} key={i}>
                                                            <li className='PublicHeader__content__menu--ul--li--childUl--li'>
                                                                {customMenuItems.careAbilitySlings.name}
                                                            </li>
                                                        </a>
                                                    </ul>
                                                </li>
                                            </div>;
                                        }

                                        return <div key={i}>
                                            <li className='PublicHeader__content__menu--ul--li' >
                                                <span onClick={() => this.goToProducts()}>{menu.title}
                                                    <FontAwesomeIcon icon={faCaretDown} size='1x' color='#fff'
                                                        style={{ marginLeft: '6px' }} />
                                                </span>
                                                <ul className='PublicHeader__content__menu--ul--li--childUl'>
                                                    {categories.map((child, i) =>
                                                        <a href={ROUTES.CATEGORY_DETAILS(child.slug)} role='button' onClick={(e) => this.routeProduct(e, child)}
                                                            key={i}>
                                                            <li className='PublicHeader__content__menu--ul--li--childUl--li'>
                                                                {child.name}
                                                            </li>
                                                        </a>
                                                    )}
                                                    <a href={customMenuItems.careAbilitySlings.url} key={i}>
                                                        <li className='PublicHeader__content__menu--ul--li--childUl--li'>
                                                            {customMenuItems.careAbilitySlings.name}
                                                        </li>
                                                    </a>
                                                </ul>
                                            </li>
                                        </div>;
                                    } else {
                                        if (menu.child_items) {
                                            if (width < 992) {
                                                return <div key={i}>
                                                    <li className='PublicHeader__content__menu--ul--li' onClick={() => this.toggleSubMemu(menu.title)} >
                                                        {menu.title}
                                                        <FontAwesomeIcon icon={faCaretDown} size='1x' color='#fff'
                                                            style={{ marginLeft: '6px' }} />

                                                        <ul className='PublicHeader__content__menu--ul--li--childUl' style={{ display: openedSubmenu === menu.title ? 'contents' : 'none' }}>
                                                            {menu.child_items.map((child, i) =>
                                                                <a href={child.url} key={i}>
                                                                    <li className='PublicHeader__content__menu--ul--li--childUl--li'>
                                                                        {child.title}
                                                                    </li>
                                                                </a>
                                                            )}
                                                        </ul>
                                                    </li>
                                                </div>;
                                            }

                                            return <div onClick={() => { location.href = menu.url; ''; }} key={i}>
                                                <li className='PublicHeader__content__menu--ul--li' >
                                                    {menu.title}
                                                    <FontAwesomeIcon icon={faCaretDown} size='1x' color='#fff'
                                                        style={{ marginLeft: '6px' }} />

                                                    <ul className='PublicHeader__content__menu--ul--li--childUl'>
                                                        {menu.child_items.map((child, i) =>
                                                            <a href={child.url} key={i}>
                                                                <li className='PublicHeader__content__menu--ul--li--childUl--li'>
                                                                    {child.title}
                                                                </li>
                                                            </a>
                                                        )}
                                                    </ul>
                                                </li>
                                            </div>;
                                        } else {
                                            return <a href={menu.url} key={i}>
                                                <li className='PublicHeader__content__menu--ul--li'>
                                                    {menu.title}
                                                </li>
                                            </a>;
                                        }
                                    }
                                })
                                }
                            </ul>
                        </div>
                        <div className='PublicHeader__content__contact'>
                            <div className='PublicHeader__content__contact__info'>
                                {Phone}
                                <div className='PublicHeader__content__contact__info--number'>
                                    01924 840 100
                                </div>
                            </div>
                            <div className='PublicHeader__content__contact__info--email'>
                                <a href='mailto:info@prismmedical.co.uk'>info@prismmedical.co.uk</a>
                            </div>
                        </div>
                    </div>
                </Wrapper>
            </div >
        );
    }
}

export default withRouter(PublicHeader);
